/** Elements that may receive two-finger pinch (custom hook or Leaflet map). */
export const PINCH_ZOOM_ZONE_SELECTOR =
  '.pinch-zoom-zone, .leaflet-container, .leaflet-pane';

function isPinchZoomZone(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(PINCH_ZOOM_ZONE_SELECTOR) !== null;
}

/**
 * Blocks iOS Safari / PWA viewport pinch-zoom on the page shell.
 * Chart zoom uses `usePinchZoom` inside `.pinch-zoom-zone`; maps use Leaflet.
 */
export function installPreventPagePinchZoom(): void {
  const blockIfOutsideZone = (e: Event) => {
    if (!isPinchZoomZone(e.target)) {
      e.preventDefault();
    }
  };

  document.addEventListener('gesturestart', blockIfOutsideZone, { passive: false });
  document.addEventListener('gesturechange', blockIfOutsideZone, { passive: false });
  document.addEventListener('gestureend', blockIfOutsideZone, { passive: false });

  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length >= 2) blockIfOutsideZone(e);
    },
    { passive: false },
  );
}
